module.exports = __webpack_public_path__ + "img/white_star.69986b0b.svg";